import { createAction, props } from '@ngrx/store';
import {
  ActuacionContractual,
  CreateActuacionContractualRequest,
  UpdateActuacionContractualRequest
} from '../models/actuacion-contractual.interface';

// Load Actions
export const loadActuacionesContractuales = createAction(
  '[Actuacion Contractual] Load Actuaciones Contractuales',
  props<{ force?: boolean }>()
);

export const loadActuacionesContractualesSuccess = createAction(
  '[Actuacion Contractual] Load Actuaciones Contractuales Success',
  props<{ actuacionesContractuales: ActuacionContractual[]; loadedAt?: number }>()
);

export const loadActuacionesContractualesFailure = createAction(
  '[Actuacion Contractual] Load Actuaciones Contractuales Failure',
  props<{ error: string }>()
);

// Create Actions
export const createActuacionContractual = createAction(
  '[Actuacion Contractual] Create Actuacion Contractual',
  props<{ actuacionContractual: CreateActuacionContractualRequest }>()
);

export const createActuacionContractualSuccess = createAction(
  '[Actuacion Contractual] Create Actuacion Contractual Success',
  props<{ actuacionContractual: ActuacionContractual }>()
);

export const createActuacionContractualFailure = createAction(
  '[Actuacion Contractual] Create Actuacion Contractual Failure',
  props<{ error: string }>()
);

// Update Actions
export const updateActuacionContractual = createAction(
  '[Actuacion Contractual] Update Actuacion Contractual',
  props<{ id: number; actuacionContractual: UpdateActuacionContractualRequest }>()
);

export const updateActuacionContractualSuccess = createAction(
  '[Actuacion Contractual] Update Actuacion Contractual Success',
  props<{ actuacionContractual: ActuacionContractual }>()
);

export const updateActuacionContractualFailure = createAction(
  '[Actuacion Contractual] Update Actuacion Contractual Failure',
  props<{ error: string }>()
);

// Toggle Status Actions
export const toggleActuacionContractualStatus = createAction(
  '[Actuacion Contractual] Toggle Actuacion Contractual Status',
  props<{ id: number; isActive: boolean }>()
);

export const toggleActuacionContractualStatusSuccess = createAction(
  '[Actuacion Contractual] Toggle Actuacion Contractual Status Success',
  props<{ id: number; isActive: boolean }>()
);

export const toggleActuacionContractualStatusFailure = createAction(
  '[Actuacion Contractual] Toggle Actuacion Contractual Status Failure',
  props<{ error: string }>()
);

// Delete Actions
export const deleteActuacionContractual = createAction(
  '[Actuacion Contractual] Delete Actuacion Contractual',
  props<{ id: number }>()
);

export const deleteActuacionContractualSuccess = createAction(
  '[Actuacion Contractual] Delete Actuacion Contractual Success',
  props<{ id: number }>()
);

export const deleteActuacionContractualFailure = createAction(
  '[Actuacion Contractual] Delete Actuacion Contractual Failure',
  props<{ error: string }>()
);

// Search Actions
export const searchActuacionesContractuales = createAction(
  '[Actuacion Contractual] Search Actuaciones Contractuales',
  props<{ query: string }>()
);

export const searchActuacionesContractualesSuccess = createAction(
  '[Actuacion Contractual] Search Actuaciones Contractuales Success',
  props<{ searchResults: ActuacionContractual[] }>()
);

export const searchActuacionesContractualesFailure = createAction(
  '[Actuacion Contractual] Search Actuaciones Contractuales Failure',
  props<{ error: string }>()
);

export const clearActuacionContractualSearch = createAction('[Actuacion Contractual] Clear Search');

// Select Actions
export const selectActuacionContractual = createAction(
  '[Actuacion Contractual] Select Actuacion Contractual',
  props<{ actuacionContractual: ActuacionContractual }>()
);

export const clearActuacionContractualSelection = createAction(
  '[Actuacion Contractual] Clear Selection'
);
